import React from 'react'
import PropTypes from 'prop-types';
import {LoadingIndicator} from '../../index';
import CountdownTimer from "../../CountdownTimer";

function LoadingWrapperWithTimer(props) {
    const {loading, children, noPadding, showTimer, seconds} = props;

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '1rem'
            }}>
                <LoadingIndicator noPadding={noPadding}/>
                {showTimer && <CountdownTimer
                    deadlineDate={new Date(new Date().getTime() + seconds * 1000)}
                />}
            </div>);
    }

    return (
        children
    );

}

LoadingWrapperWithTimer.propTypes = {
    children: PropTypes.node.isRequired,
    loading: PropTypes.bool.isRequired,
    noPadding: PropTypes.bool,
    showTimer: PropTypes.bool,
    seconds: PropTypes.number,
};

export default LoadingWrapperWithTimer;